import { render, staticRenderFns } from "./RightFooterComponent.vue?vue&type=template&id=2b12ceb8&"
import script from "./RightFooterComponent.vue?vue&type=script&lang=js&"
export * from "./RightFooterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports